import "../../styles/partials/privacyPolicy.scss";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <section className="section">
        <div className="section-header">
          <div className="container">
            <h2>Privacy Policy</h2>
          </div>
        </div>

        <div className="container">
          <div className="privacy-content">
            <div className="privacy-section">
              <h3>Information We Collect</h3>
              <p>
                At TGC Limited, we collect information you provide directly to us, such as when you:
              </p>
              <ul>
                <li>Contact us through our contact form</li>
                <li>Subscribe to our newsletters or updates</li>
                <li>Request product information or quotes</li>
                <li>Communicate with us via email or phone</li>
              </ul>
              <p>
                The information we collect may include your name, email address, phone number, 
                company name, and any other information you choose to provide.
              </p>
            </div>

            <div className="privacy-section">
              <h3>How We Use Your Information</h3>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Respond to your inquiries and provide customer service</li>
                <li>Send you information about our agricultural products</li>
                <li>Process your orders and requests</li>
                <li>Improve our website and services</li>
                <li>Communicate with you about our products and services</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h3>Information Sharing</h3>
              <p>
                We do not sell, trade, or otherwise transfer your personal information to third parties 
                without your consent, except as described in this policy. We may share your information:
              </p>
              <ul>
                <li>With service providers who assist us in operating our website</li>
                <li>When required by law or to protect our rights</li>
                <li>In connection with a business transfer or merger</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h3>Data Security</h3>
              <p>
                We implement appropriate security measures to protect your personal information 
                against unauthorized access, alteration, disclosure, or destruction. However, 
                no method of transmission over the internet is 100% secure.
              </p>
            </div>

            <div className="privacy-section">
              <h3>Cookies</h3>
              <p>
                Our website may use cookies to enhance your browsing experience. You can 
                choose to disable cookies through your browser settings, though this may 
                affect some functionality of our website.
              </p>
            </div>

            <div className="privacy-section">
              <h3>Contact Information</h3>
              <p>
                If you have questions about this Privacy Policy, please contact us at:
              </p>
              <div className="contact-details">
                <p><strong>Email:</strong> enquiries@trinitygoldencrownltd.com</p>
                <p><strong>Phone:</strong> +2348165224307, +2348111784179</p>
                <p><strong>Address:</strong> 1. Chief Bode Moses street, Ibafo, Lagos-Ibadan express-way, 
                Obafemi-owode LGA, Ogun State, Nigeria</p>
              </div>
            </div>

            <div className="privacy-section">
              <h3>Changes to This Policy</h3>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any 
                changes by posting the new Privacy Policy on this page. Changes are effective 
                when posted on this page.
              </p>
              <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;